import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { RootState } from "../redux/store";
import {
    fetchEligibleClubsByPhone,
 
  joinSelectedClubs,
  removeJoinedClubs,
} from "../redux/slices/groupSlice";

const JoinClubPage: React.FC = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const { eligibleGroups = [], loading, joining } = useSelector(
    (state: RootState) => state.group
  );

  const [selectedClubs, setSelectedClubs] = useState<any[]>([]);

  const phoneNumber =
    user?.phone_number ||
    user?.user_mobile ||
    localStorage.getItem("public_mobile") ||
    "";
useEffect(() => {
  if (phoneNumber) {
    dispatch(fetchEligibleClubsByPhone(phoneNumber));
  }
}, [dispatch, phoneNumber]);

  const totalClubs = eligibleGroups.length;

  const isClubSelected = (contactId: number) => {
    return selectedClubs.some((item) => item.contact_id === contactId);
  };

  const toggleClub = (club: any) => {
    setSelectedClubs((prev) => {
      const exists = prev.some(
        (item) => item.contact_id === club.contact_id
      );

      if (exists) {
        return prev.filter(
          (item) => item.contact_id !== club.contact_id
        );
      }

      return [
        ...prev,
        {
          client_id: club.client_id,
          client_name: club.client_name,
          contact_id: club.contact_id,
          contact_name: club.contact_name,
          contact_mobile: club.contact_mobile,
        },
      ];
    });
  };

  const handleJoinClubs = async () => {
    if (!user?.user_id) {
      toast.error("Login required to join club");
      navigate("/login");
      return;
    }

    if (selectedClubs.length === 0) {
      toast.error("Please select at least one club");
      return;
    }

    const res = await dispatch(
      joinSelectedClubs({
        user_id: user.user_id,
        clubs: selectedClubs.map((club: any) => ({
          contact_id: club.contact_id,
        })),
      })
    );

    if (
      joinSelectedClubs.fulfilled.match(res) &&
      (res.payload?.success === true || res.payload?.status === true)
    ) {
      const joinedContactIds = selectedClubs.map(
        (club: any) => club.contact_id
      );

      dispatch(removeJoinedClubs(joinedContactIds));
      setSelectedClubs([]);

      toast.success("Clubs joined successfully");

      const remainingClubs = eligibleGroups.filter(
        (club: any) => !joinedContactIds.includes(club.contact_id)
      );

      if (remainingClubs.length === 0) {
        navigate("/home");
      }
    } else {
      toast.error(res.payload?.message || "Failed to join clubs");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.headerBox}>
          <h1 style={styles.title}>Join Clubs</h1>
          <p style={styles.subTitle}>
            Select your clubs. Groups will be unlocked automatically.
          </p>
        </div>

        <div style={styles.formBox}>
          <div style={styles.sectionHeader}>
            <label style={styles.label}>Available Clubs</label>

            {!loading && totalClubs > 0 && (
              <span style={styles.countBadge}>
                {totalClubs} club{totalClubs > 1 ? "s" : ""}
              </span>
            )}
          </div>

          {loading && (
            <div style={styles.loadingBox}>Checking eligible clubs...</div>
          )}

          {!loading && totalClubs === 0 && (
            <div style={styles.emptyBox}>
              <p style={styles.emptyTitle}>No eligible club found</p>
              <p style={styles.emptyText}>
                Your number has no pending club linking.
              </p>
            </div>
          )}

          {!loading &&
            eligibleGroups.map((club: any) => {
              const selected = isClubSelected(club.contact_id);

              return (
                <div
                  key={`${club.client_id}-${club.contact_id}`}
                  style={{
                    ...styles.clubCard,
                    borderColor: selected ? "#2563eb" : "#dbe3ef",
                    background: selected ? "#eff6ff" : "#ffffff",
                  }}
                  onClick={() => toggleClub(club)}
                >
                  <div style={styles.clubTopRow}>
                    <span
                      style={{
                        ...styles.checkbox,
                        background: selected ? "#2563eb" : "#ffffff",
                        color: selected ? "#ffffff" : "transparent",
                      }}
                    >
                      ✓
                    </span>

                    <div style={styles.clubHeader}>
                      <h4 style={styles.clubName}>{club.client_name}</h4>
                      <p style={styles.clubSubText}>
                        {club.contact_name || "-"} •{" "}
                        {club.groups?.length || 0} group
                        {(club.groups?.length || 0) > 1 ? "s" : ""}
                      </p>
                    </div>
                  </div>

                  <div style={styles.groupList}>
                    {(club.groups || []).map((group: any) => (
                      <div key={group.group_id} style={styles.groupRow}>
                        <span style={styles.groupTextBox}>
                          <span style={styles.groupRowText}>
                            {group.group_name}
                          </span>
                          <span style={styles.designationText}>
                            {group.designation_name || "-"}
                          </span>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}

          <button
            onClick={handleJoinClubs}
            disabled={loading || joining || selectedClubs.length === 0}
            style={{
              ...styles.button,
              opacity:
                loading || joining || selectedClubs.length === 0 ? 0.65 : 1,
              cursor:
                loading || joining || selectedClubs.length === 0
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {joining
              ? "Joining..."
              : selectedClubs.length > 0
              ? `Join ${selectedClubs.length} Club${
                  selectedClubs.length > 1 ? "s" : ""
                }`
              : "Select Club to Continue"}
          </button>

          <button
            type="button"
            onClick={() => navigate("/home")}
            style={styles.skipButton}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
};

const styles: any = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f8fbff",
    padding: "18px",
  },
  card: {
    width: "100%",
    maxWidth: "430px",
    background: "#ffffff",
    borderRadius: "26px",
    padding: "24px",
    boxShadow: "0 22px 60px rgba(15, 23, 42, 0.13)",
  },
  headerBox: {
    textAlign: "center",
    marginBottom: "18px",
  },
  title: {
    margin: 0,
    fontSize: "23px",
    fontWeight: 700,
    color: "#0f172a",
  },
  subTitle: {
    marginTop: "7px",
    fontSize: "13px",
    color: "#64748b",
    lineHeight: 1.45,
  },
  formBox: {
    display: "flex",
    flexDirection: "column",
    gap: "11px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#0f172a",
  },
  countBadge: {
    padding: "5px 10px",
    borderRadius: "999px",
    background: "#eff6ff",
    color: "#2563eb",
    fontSize: "11px",
    fontWeight: 500,
  },
  loadingBox: {
    padding: "18px",
    borderRadius: "16px",
    background: "#f8fbff",
    border: "1px solid #e2e8f0",
    textAlign: "center",
    fontSize: "13px",
    color: "#64748b",
  },
  emptyBox: {
    padding: "22px",
    borderRadius: "16px",
    background: "#fff7f7",
    border: "1px solid #fecaca",
    textAlign: "center",
  },
  emptyTitle: {
    margin: 0,
    fontSize: "13px",
    fontWeight: 600,
    color: "#991b1b",
  },
  emptyText: {
    margin: "7px 0 0",
    fontSize: "11px",
    color: "#ef4444",
  },
  clubCard: {
    padding: "12px",
    borderRadius: "16px",
    border: "1px solid #dbe3ef",
    cursor: "pointer",
  },
  clubTopRow: {
    display: "flex",
    gap: "10px",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  clubHeader: {
    flex: 1,
  },
  clubName: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
  },
  clubSubText: {
    margin: "3px 0 0",
    fontSize: "11px",
    color: "#64748b",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    minWidth: "20px",
    borderRadius: "6px",
    border: "1px solid #cbd5e1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    fontWeight: 500,
    marginTop: "1px",
  },
  groupList: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginLeft: "30px",
  },
  groupRow: {
    width: "100%",
    padding: "8px 10px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    background: "#ffffff",
  },
  groupTextBox: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  groupRowText: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#0f172a",
  },
  designationText: {
    fontSize: "11px",
    fontWeight: 400,
    color: "#64748b",
  },
  button: {
    width: "100%",
    minHeight: "48px",
    borderRadius: "16px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb, #0284c7)",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "4px",
  },
  skipButton: {
    width: "100%",
    border: "none",
    background: "transparent",
    color: "#64748b",
    fontSize: "13px",
    fontWeight: 400,
    marginTop: "2px",
    cursor: "pointer",
  },
};

export default JoinClubPage;